import React from 'react';
import { SlackPromoConfluenceIneligibleFormView } from './views';

export function SlackPromoConfluenceFormView() {
  return <SlackPromoConfluenceIneligibleFormView />;
}
